module.exports = __webpack_public_path__ + "static/media/one_pote_pricing.0920c021.png";